
exports.STATS_PROJECTION_DAY_COUNTS = [1,2,3,4,5,6,7,8,9,10,11,12,13,14]

exports.MEDIAN_FIRST_24HR_FRACTION_OF_TOTAL_VIEWS = 0.74

// https://docs.google.com/spreadsheets/d/1uEZpZtT1eAp2cKaIh5_JSm-fDjMl5e3DriXOmOEHIIM/edit#gid=305751610&range=A1079
exports.MEDIAN_24HR_GROWTH_MULTIPLIER_LIST = [
  { day: 0.5, growthMultiplier : 0.07 },
  { day: 1.5, growthMultiplier : 0.6 },
  { day: 2.5, growthMultiplier : 0.7 },
  { day: 3.5, growthMultiplier : 0.76 },
]

// https://docs.google.com/spreadsheets/d/1_BlZEUCWVabE5gnQPBe6L4rD_py6D9jhx25v9suL27M/edit#gid=1460598157&range=A4:N4
exports.MEDIAN_24HR_ENGAGEMENT_GROWTH_MULTIPLIER_LIST = [
  { day: 5.5, growthMultiplier: 0.8 },
  { day: 6.5, growthMultiplier: 0.7 },
]

exports.DEFAULT_PREVIEW_CLICK_RATE = 0.334
exports.DEFAULT_APPLICATION_RATE = 0.675
exports.DEFAULT_AVG_DAILY_APPLICATION_VELOCITY = 39.52
exports.DEFAULT_AVG_APPLICATION_APPROVAL_RATE = 0.239
exports.DEFAULT_AVG_DRAFT_UPLOAD_RATE = 0.195
exports.DEFAULT_AVG_SUBMISSION_RATE_WITH_DRAFT = 0.865
exports.DEFAULT_AVG_SUBMISSION_RATE_CPM_WITHOUT_DRAFT = 0.308
exports.DEFAULT_AVG_SUBMISSION_RATE_CUSTOM_WITHOUT_DRAFT = 0.346

// https://docs.google.com/spreadsheets/d/1uEZpZtT1eAp2cKaIh5_JSm-fDjMl5e3DriXOmOEHIIM/edit#gid=351217186
exports.ERROR_PERCENTILE_LIST = [
  0.142904555,
  0.2929284927,
  0.4390628192,
  0.6680810849,
  1,
  1.31105425,
  1.95943164,
  3.083550597,
  5.275559975,
]
